<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'DouYinGoods',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'userName',
        placeholder: '抖音昵称',
        type: 'input'
      }],
      permission: {
        add: 'douYinGoods:add',
        update: 'douYinGoods:update',
        delete: 'douYinGoods:delete',
        deleteBatch: 'douYinGoods:deleteBatch'
      },
      url: {
        get: '/douYinGoods/listByCondition',
        add: '/douYinGoods/add',
        update: '/douYinGoods/update',
        delete: '/douYinGoods/delete',
        delete_batch: '/douYinGoods/deleteBatch',
        status: '/douYinGoods/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'userName',  // 字段名
        label: '抖音昵称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'douYinId',  // 字段名
        label: '抖音ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'goodsId',  // 字段名
        label: '商品ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'status',  // 字段名
        label: '状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '已采集',
            type: 'success'
          }, {
            key: 1,
            value: '未采集',
            type: 'info'
          }]
        },
      },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'goodsId',  // 字段名
            label: 'goodsId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入goodsId',
            rules: [
              {required: true, message: 'goodsId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'userName',  // 字段名
            label: 'userName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userName',
            rules: [
              {required: true, message: 'userName不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'douYinId',  // 字段名
            label: 'douYinId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入douYinId',
            rules: [
              {required: true, message: 'douYinId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
